import React from "react";
import { Badge, Divider, Chip, Box } from "@material-ui/core";
import { getLocationViewName } from "../../../utils/locationUtils";
import { BayMenu } from "./BayMenu";

export const StructuredLocationMap = ({
  classes,
  bayList,
  setBayList,
  confirmDeleteBay,
  handleAddLevel,
  setInventoryType,
  getBadgeContent,
  handleMenuOpen,
}) => {
  if (!bayList || bayList.length === 0) {
    return <Box p={2} textAlign="center"></Box>;
  }

  return (
    <div className={classes.location}>
      {bayList.map((bay, bayIdx) => (
        <div key={`bay_${bayIdx}`} className={classes.bayContainer}>
          <div className={classes.item}>
            <BayMenu
              bayNumber={bayIdx}
              handleDeleteBay={confirmDeleteBay}
              handleAddLevel={handleAddLevel}
              setInventoryType={setInventoryType}
              bayList={bayList}
              setBayList={setBayList}
              classes={classes}
            />
          </div>
          <Divider className={classes.divider} />
          {bay.map((level, levelIdx) => (
            <div key={`level_${levelIdx}`} className={classes.levelContainer}>
              {level.map((location) => {
                return (
                  <Badge
                    key={location.id}
                    color="primary"
                    badgeContent={getBadgeContent(location)}
                  >
                    <Chip
                      label={getLocationViewName(location)}
                      clickable
                      onClick={(evt) => handleMenuOpen(evt, location)}
                      className={
                        location.capacityUsed
                          ? classes.locationUsedAvatar
                          : classes.locationAvatar
                      }
                    />
                  </Badge>
                );
              })}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
